import React, { useState } from 'react'
import { Button } from '@material-ui/core'

import { snackbar } from 'components'
import { ERRORS } from 'consts'
// eslint-disable-next-line import/named
import { useApi, useApiCall } from 'hooks'
import { APP_COLORS } from 'styles/appColors'
import { STORE_COLORS } from 'styles/storeColors'
import { COLORS } from 'styles'

import { useStyles } from './styles'
import { createStyle, getStyles } from './api'
import { AppColors, Colors, GetStyleResponse, Style, StyleParams } from './types'
import { AppMobile } from './AppMobile'

const Styles: React.FC = () => {
  const [logoImage] = useState<File | undefined>(undefined)
  const [logoChanged] = useState<boolean>(false)
  const [appLogoImage, setAppLogoImage] = useState<File | undefined>(undefined)
  const [appLogoChanged, setAppLogoChanged] = useState<boolean>(false)
  const [homeImage, setHomeImage] = useState<File | undefined>(undefined)
  const [bannerImage, setBannerImage] = useState<File | undefined>(undefined)
  const [nextEventsImage, setNextEventsImage] = useState<File | undefined>(undefined)
  const [homeChanged, setHomeChanged] = useState<boolean>(false)
  const [bannerChanged, setBannerChanged] = useState<boolean>(false)
  const [nextEventsChanged, setnextEventsChanged] = useState<boolean>(false)
  const [storeLogoImage] = useState<File | undefined>(undefined)
  const [storeLogoChanged] = useState<boolean>(false)

  const getStyleResponseGetter = (responseData: GetStyleResponse) => {
    const { style } = responseData
    const colors: Colors = style.colors
      ? JSON.parse(style.colors.toString())
      : {
          PRIMARY_MAIN: COLORS.BASE,
          PRIMARY_CONTRAST: COLORS.LIGHT_GREY,
          SECONDARY_MAIN: COLORS.ACCENT,
          BACKGROUND: COLORS.PRIMARY_BACKGROUND,
        }
    const appColors: AppColors = style.appColors
      ? JSON.parse(style.appColors.toString())
      : { ...APP_COLORS }
    const storeColors: Colors = style.storeColors
      ? JSON.parse(style.storeColors.toString())
      : { ...STORE_COLORS }
    return {
      ...style,
      colors,
      appColors,
      storeColors,
    }
  }
  const [{ data: style, isLoading }, , setStyle] = useApi<GetStyleResponse, Style>(
    getStyles,
    getStyleResponseGetter,
    {
      baseData: {
        id: 0,
        colors: {
          PRIMARY_MAIN: '',
          PRIMARY_CONTRAST: '',
          SECONDARY_MAIN: '',
          BACKGROUND: '',
        },
        storeColors: {
          PRIMARY_MAIN: '',
          PRIMARY_CONTRAST: '',
          SECONDARY_MAIN: '',
          BACKGROUND: '',
        },
        appColors: {
          $PRIMARY_BACKGROUND: '',
          $SECONDARY_BACKGROUND: '',
        },
        logoUrl: '',
        homeUrl: '',
        appLogoUrl: '',
        storeLogoUrl: '',
        bannerUrl: '',
        nextEventUrl: '',
      },
      onError: () => snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE),
    },
  )

  const [saveStyle, isSavingStyle] = useApiCall<StyleParams, GetStyleResponse>(createStyle)

  const classes = useStyles()

  const save = async () => {
    try {
      const req = {
        colors: style.colors,
        appColors: style.appColors,
        storeColors: style.storeColors,
        logo: logoImage,
        appLogo: appLogoImage,
        home: homeImage,
        banner: bannerImage,
        storeLogo: storeLogoImage,
        nextEvent: nextEventsImage,
        logoChanged,
        appLogoChanged,
        homeChanged,
        bannerChanged,
        storeLogoChanged,
        nextEventChanged: nextEventsChanged,
      }
      await saveStyle(req)
      window.location.reload()
    } catch (err) {
      console.error(err)
      snackbar.show('No se pudo editar el estilo. Intente de nuevo.')
    }
  }

  const handleAppLogoChange = (file: File | undefined) => {
    setAppLogoChanged(true)
    setAppLogoImage(file)
  }

  const handleHomeChange = (file: File | undefined) => {
    setHomeChanged(true)
    setHomeImage(file)
  }

  const handleBannerChange = (file: File | undefined) => {
    setBannerChanged(true)
    setBannerImage(file)
  }

  const handleNextEventsChange = (file: File | undefined) => {
    setnextEventsChanged(true)
    setNextEventsImage(file)
  }

  return (
    <>
      <div className={classes.pageBody}>
        {!isLoading ? (
          <AppMobile
            style={style}
            setStyle={setStyle}
            setLogoFile={handleAppLogoChange}
            setHomeFile={handleHomeChange}
            setBannerFile={handleBannerChange}
            setNextEventsFile={handleNextEventsChange}
            onSave={save}
          />
        ) : null}
      </div>
      <div className={classes.pageActions}>
        <Button
          onClick={save}
          variant="contained"
          color="primary"
          disabled={
            isLoading || isSavingStyle || (!homeChanged && !bannerChanged && !nextEventsChanged)
          }
        >
          Guardar cambios
        </Button>
      </div>
    </>
  )
}

export { Styles }
